import React from 'react';

import ExternalLink from 'components/generic/ExternalLink.component';

import CN from './CardItem.module.scss';

const CardItem = ({ imageSrc, title, link }) => (
  <div data-bem="CardItem" className={CN.component}>
    <div className={CN.imageContainer}>
      <img src={imageSrc} alt={title} />
    </div>

    <div className={CN.cardInfo}>
      <div className={CN.title}>{title}</div>

      <ExternalLink link={link} variant="card">
        LEARN MORE
      </ExternalLink>
    </div>
  </div>
);

export default CardItem;
